import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export type BANCO_DI_FLUSSAGGIO_InfoProps = {
  nodo: NodoDto;
};

function formatSeconds(value: string | null | undefined): string {
  if (!value) {
    return "-";
  }

  const total = Number(value);
  if (!Number.isFinite(total)) {
    return value;
  }

  const seconds = Math.max(0, Math.floor(total));
  const hh = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const mm = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const ss = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

function InfoItem({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="caption">{label}</Typography>
      <Typography variant="h4">{value}</Typography>
    </Box>
  );
}

export function BANCO_DI_FLUSSAGGIO_Info({
  nodo,
}: BANCO_DI_FLUSSAGGIO_InfoProps) {
  const { t } = useTranslation();
  const info = nodo.dispositivoLastInfo;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa recircolo (ore totali)"
            value={info?.ctorepr ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa flussaggio (ore totali)"
            value={info?.ctorepf ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa contaparticelle (ore totali)"
            value={info?.cporepr ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa recircolo (ore parziali)"
            value={info?.ctoreprtot ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa flussaggio (ore parziali)"
            value={info?.ctorepftot ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Contaore pompa contaparticelle (ore parziali)"
            value={info?.ctorecptot ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Timer"
            value={formatSeconds(info?.timersectot)}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Parziale 1"
            value={formatSeconds(info?.parsec1tot)}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Parziale 2"
            value={formatSeconds(info?.parsec2tot)}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoItem
            label="Parziale 3"
            value={formatSeconds(info?.parsec3tot)}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
